import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, LogIn } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import Layout from "../components/Layout";
import PasswordInput from "../components/PasswordInput";

export default function AdminLogin() {
  const { login, admin } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (admin) nav("/admin");
  }, [admin, nav]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(err.response?.data?.detail || "Credenciais inválidas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <section className="min-h-[70vh] flex items-center py-24">
        <div className="max-w-md mx-auto px-6 w-full">
          <div className="dossier p-10">
            <div className="flex items-center gap-3 mb-2">
              <Lock className="w-4 h-4 text-blood" />
              <p className="mono text-[10px] tracking-[0.3em] text-blood">ACESSO RESTRITO</p>
            </div>
            <h1 className="headline text-3xl mb-2">Painel de administração</h1>
            <p className="text-bone-muted text-sm mb-8">Apenas pessoal autorizado.</p>

            <form onSubmit={onSubmit} className="space-y-5">
              <div>
                <label className="mono text-[10px] tracking-[0.3em] text-bone-faded block mb-2">
                  EMAIL
                </label>
                <input
                  data-testid="admin-email-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full bg-ink-200 border border-white/10 px-4 py-3 mono text-sm focus:outline-none focus:border-blood transition-colors"
                />
              </div>
              <div>
                <label className="mono text-[10px] tracking-[0.3em] text-bone-faded block mb-2">
                  PASSWORD
                </label>
                <PasswordInput
                  testId="admin-password-input"
                  value={password}
                  onChange={setPassword}
                  autoComplete="current-password"
                />
              </div>
              {error && (
                <p className="text-blood mono text-xs tracking-[0.2em]">{String(error)}</p>
              )}
              <button
                type="submit"
                disabled={loading}
                data-testid="admin-login-submit"
                className="btn-primary w-full justify-center disabled:opacity-60"
              >
                {loading ? "A entrar..." : (<>Entrar <LogIn className="w-4 h-4" /></>)}
              </button>
            </form>
          </div>
        </div>
      </section>
    </Layout>
  );
}
